import React, { useState, useEffect,useRef  } from "react";
import { useMediaQuery } from 'react-responsive';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const PowerDetails = [
    {
      heading: "Recognize & Retarget Instantly",
      content: "Experiment with different pop-up variations to see which drives the best results."
    },
    {
      heading: "Automate Retargeting",
      content: "Trigger WhatsApp, SMS & email campaigns in real-time based on user actions."
    },
    {
      heading: "Recover Abandoned Carts",
      content: "Instantly reach out with targeted offers when a user drops off."
    },
    {
      heading: "Enhance Customer Retention",
      content: "Use deep insights to re-engage customers and drive repeat purchases."
    },
    {
      heading: "Drive Higher Conversions",
      content: "Leverage AI-driven segmentation and personalized messaging for better sales."
    }
  ];



export const SectionFour = () => {


 const isMobile = useMediaQuery({ maxWidth: 768 });



;


  const sections1 = [
    {id:1,image:"/assets/images/kwikpass/group1.png"},
    {id:2,image:"/assets/images/kwikpass/group2.png"},
    {id:3,image:"/assets/images/kwikpass/group3.png"},
    {id:4,image:"/assets/images/kwikpass/group4.png"},
    {id:5,image:"/assets/images/kwikpass/group5.png"}
  ];
  
  const settingsmob = {
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "40px",
    arrows: false, // Hide default arrows
    dots: false,   // Hide navigation dots
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
        },
      },
    ],
  };




  return (
    <div className="section-2">
      <div className="container-fluid">
   
        <div className="container-fulid fourth">
          
            <div className="top-text growth">
              <h1>Powering E-commerce Everywhere</h1>
              <p>
              Wherever You Sell, We Help You Identify & Engage More Shoppers.
              </p>
            </div>
 
     
        </div>

        <div className="container-fluid">

        <div className="container">
        <div className="layout-container">

            <div className="center-container">
                <div className="central-image d-none d-lg-block" >
                    <img src="/assets/images/kwikengage/kwikengage.png" alt="KwikPass with Arrows" style={{height:"340px",width:"auto"}}/>
                </div>  
            </div>
            
     
            <div className="feature-box top d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/public.png" alt="Shopify" className="icon"/>
                </div>
                <h4>Shopify Public App</h4>
                <p>One-click integration for Shopify merchants to enable customer identification and engagement.</p>
            </div>
            
            <div className="feature-box top-right d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/store.png" alt="Custom Store" className="icon"/>
                </div>
                <h4>Shopify Custom Stores</h4>
                <p>Supports tailored Shopify implementations, ensuring seamless login and pop-up functionality.</p>
            </div>

            <div className="feature-box bottom-right d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/appmaker.png" alt="App" className="icon"/>
                </div>
                <h4>Appmaker & Appbrew</h4>
                <p>Enables brands using these platforms to enhance user identification and marketing pop-ups.</p>
            </div>
            
           
            <div className="feature-box bottom-left d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/customweb.png" alt="Website" className="icon"/>
                </div>
                <h4>Custom-Built Websites</h4>
                <p>Easily integrates with any proprietary website to power secure user authentication and engagement.</p>
            </div>
            
   
            <div className="feature-box top-left d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/android.png" alt="Mobile" className="icon"/>
                </div>
                <h4>Android Mobile App</h4>
                <p>Extends seamless login and engagement capabilities to mobile-first businesses.</p>
            </div>
        </div>
        

        <div className="row feature-row d-lg-none">
            <div className="col-12 col-md-6">
                <div className="feature-box" >
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/public.png" alt="Shopify" className="icon"/>
                    </div>
                    <h4>Shopify Public App</h4>
                    <p>One-click integration for Shopify merchants to enable customer identification and engagement.</p>
                </div>
            </div>
            
            <div className="col-12 col-md-6">
                <div className="feature-box">
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/store.png" alt="Custom Store" className="icon"/>
                    </div>
                    <h4>Shopify Custom Stores</h4>
                    <p>Supports tailored Shopify implementations, ensuring seamless login and pop-up functionality.</p>
                </div>
            </div>
            
            <div className="col-12 col-md-6">
                <div className="feature-box">
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/appmaker.png" alt="App" className="icon"/>
                    </div>
                    <h4>Appmaker & Appbrew</h4>
                    <p>Enables brands using these platforms to enhance user identification and marketing pop-ups.</p>
                </div>
            </div>
            
            <div className="col-12 col-md-6">
                <div className="feature-box">
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/customweb.png" alt="Website" className="icon"/>
                    </div>
                    <h4>Custom-Built Websites</h4>
                    <p>Easily integrates with any proprietary website to power secure user authentication and engagement.</p>
                </div>
            </div>
            
            <div className="col-12 col-md-6">
                <div className="feature-box">
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/android.png" alt="Mobile" className="icon"/>
                    </div>
                    <h4>Android Mobile App</h4>
                    <p>Extends seamless login and engagement capabilities to mobile-first businesses.</p>
                </div>
            </div>
        </div>
    </div>






    </div>

    <div className="container-fluid fourth d-flex justify-content-center align-items-center">

    <div className="top-text  text-center">

        <div className="btn">
          <a href="https://www.gokwik.co/contact?utm_source=productpage&utm_medium=KwikPass" target='_blank'>
            <button className="cta">Book a Demo</button>
          </a>
          <a href="https://apps.shopify.com/kwikengage?utm_source=website&utm_medium=product_page_cta" target='_blank'>
            <button className="cta2 text-white">
              <img
                src="/assets/images/kwikpass/shop.png"
                alt="Shopify Logo"
                width={20}
              />
              Get It On Shopify
            </button>
          </a>
        </div>

    </div>
</div>


<div className="container-fluid mt-5 mb-5">
        <div className="sec4-heading">
          <h1>The Power Couple: KwikPass and Kwik Engage!</h1>
        </div>
        <p className='pb-5' style={{fontWeight:"100" ,color:"#FFFFFF60"}}>
          Recognize every shopper, re-engage them across channels, and unlock new revenue streams with <br />
          automated retargeting.
        </p>
        <div className='row justify-content-center' style={isMobile ? {} : {marginLeft: "200px"}}
>
          <div className="col-lg-6 col-12">
            {PowerDetails.map((item, index) => (
              <div key={index} className="mb-3">
                  <div className="sec-4head">{item.heading}</div>
                  <div className="sec-4content">{item.content}</div>
              </div>
            ))}

              <div className="btn">
                <a href="https://www.gokwik.co/product/kwikengage" target='_blank'>
                  <button className="cta">Know More</button>
                </a>
              </div>
          </div>

          <div className="col-lg-6 col-12  power-vid1">
              <div>
                <video 
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{ height: "auto", width: "268px",marginTop:"10px" }}
                >
                  <source src="/assets/images/kwikpass/pow_coup.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
          </div>
        </div>
      </div>



      </div>
    </div>
  );
};
